import { useScheduleContext } from "Hooks/useScheduleContext";
import { useState } from "react";
import { useQuery } from "react-query";
import {
  getPartnersDatesAPI,
  getPartnersHoursAPI,
} from "Requests/SchedulePartners";

export const useSelectCalendar = () => {
  const [dateRequest, setDateRequest] = useState(() => {
    const currentDate = new Date();

    const monthFormatted = String(currentDate.getMonth() + 1).padStart(2, "0");

    return `${currentDate.getFullYear()}-${monthFormatted}`;
  });

  const {
    appointment,
    setAppointmentInfo,
    personalInfo,
    createSchedule,
    loadingCreation,
    appointmentId,
  } = useScheduleContext();

  const cep = personalInfo?.cep ? personalInfo.cep : "";

  const availableDates = useQuery({
    queryKey: ["dates", dateRequest],
    queryFn: () => getPartnersDatesAPI(cep, dateRequest, appointmentId),
    refetchOnWindowFocus: false,
    enabled: !!cep,
    retry: 1,
    select: (data) => {
      const arr: any = [];
      data.forEach((date) => {
        const newDate = new Date(`${date.date}T03:00:00`);
        arr.push({
          date: newDate.toLocaleDateString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
          }),
          day: newDate.toLocaleDateString("pt-BR", { weekday: "long" }),
          query: date.date,
        });
      });

      return arr;
    },
  });

  const availableHours = useQuery({
    queryKey: ["hours", dateRequest, appointment.query_date],
    queryFn: () =>
      getPartnersHoursAPI(cep, appointment.query_date, appointmentId),
    refetchOnWindowFocus: false,
    enabled: !!appointment.query_date,
  });

  const handleSelectCalendar = (query: { option: string }) => {
    setAppointmentInfo({ query_date: query.option });
    setAppointmentInfo({ query_hour: "" });
  };

  const handleSelectHour = async (query: { option: string }) => {
    setAppointmentInfo({ query_hour: query.option });
  };

  const { data } = availableDates ?? {};

  const [pos] = data ?? [];

  const [year, month, day] = pos?.query.split("-") ?? "";
  const currentMonth = new Date(year, month - 1, day);

  const monthSelected = currentMonth.toLocaleDateString("pt-BR", {
    month: "long",
  });

  const capitilizedMonth =
    monthSelected.charAt(0).toUpperCase() + monthSelected.slice(1);

  return {
    dateRequest,
    availableDates,
    setDateRequest,
    capitilizedMonth,
    handleSelectCalendar,
    availableHours,
    appointment,
    handleSelectHour,
    createSchedule,
    loadingCreation,
    setAppointmentInfo,
  };
};
